
import {  Outlet } from "react-router-dom";

export default function Qrcode(params) {

    return<div className="main-panel"> <div className="content-wrapper"><Outlet/></div></div> 
}